import * as server from '../entries/pages/(dashboard)/profile/subscription/_page.server.ts.js';

export const index = 18;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(dashboard)/profile/subscription/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/(dashboard)/profile/subscription/+page.server.ts";
export const imports = ["_app/immutable/nodes/18.Cn62TLrR.js","_app/immutable/chunks/Bzak7iHL.js","_app/immutable/chunks/CnGaPG_y.js","_app/immutable/chunks/DIeogL5L.js","_app/immutable/chunks/BBilxCvN.js","_app/immutable/chunks/7JdHMB9Z.js","_app/immutable/chunks/BqhvobEz.js","_app/immutable/chunks/B764PkgB.js","_app/immutable/chunks/BRzKQYUk.js"];
export const stylesheets = [];
export const fonts = [];
